import Image from '@atoms/Image';
import Text from '@atoms/Text';
import React from 'react';
import texts from '@components/Products/en.json';
import LazyImage from '@atoms/LazyImage';

const InvoiceWhyInvestCard = React.memo(
    ({ title, description, icon, index }) => {
        return (
            <li
                key={index}
                className="flex flex-col h-full gap-3 p-3 shadow-lg md:p-6 bg-basicWhite rounded-xl md:gap-6"
            >
                <LazyImage src={icon} className='relative h-12 md:h-[40px]' />
                <div className="text-center ">
                    <Text
                        content={title}
                        htmlTag="h3"
                        className="inline text-center text-basicBlack p4-semibold"
                    />{' '}
                    <Text
                        content={description}
                        className="inline mb-4 text-center text-basicBlack p4-regular"
                    />
                </div>
            </li>
        );
    }
);

export const InvoiceWhyInvest = ({ productWhyInvest }) => {
    const { title, question, cards } = productWhyInvest || {};

    return (
        <div
            id="product-why-invest"
            className="flex flex-col items-center gap-4 px-4 pb-10 md:px-6 md:pb-16  md:gap-8 w-full max-w-[1136px] xl:mx-auto xl:px-0"
        >
            <div className="text-center ">
                <Text
                    content={`${question ?? texts.whyInvest} `}
                    className="inline whitespace-pre md:block text-basicBlack p3-regular md:h3-regular md:pb-2"
                />
                <Text
                    content={title}
                    className="inline md:block text-basicBlack p3-semibold md:h3-semibold"
                    htmlTag='h2'
                />
            </div>
            <ul className="grid justify-center w-full grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4 place-items-center xl:gap-x-8">
                {cards?.map((card, index) => (
                    <InvoiceWhyInvestCard {...card} index={index} />
                ))}
            </ul>
        </div>
    );
};
